import React from 'react'

const KeyOn = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <title>Key</title>
      <path
        d='M14 27.4Q12.6 27.4 11.6 26.4Q10.6 25.4 10.6 24Q10.6 22.6 11.6 21.6Q12.6 20.6 14 20.6Q15.4 20.6 16.4 21.6Q17.4 22.6 17.4 24Q17.4 25.4 16.4 26.4Q15.4 27.4 14 27.4ZM14 36Q9 36 5.5 32.5Q2 29 2 24Q2 19 5.5 15.5Q9 12 14 12Q17.6 12 20.3 13.7Q23 15.4 24.55 18.85H42.35L48 24.5L39.65 32.15L35.25 28.95L30.85 32.15L27.1 29.15H24.55Q23.3 32.15 20.625 34.075Q17.95 36 14 36ZM14 33Q16.9 33 19.35 31.075Q21.8 29.15 22.5 26.15H28.2L30.9 28.4L35.3 25.25L39.4 28.35L43.65 24.4L41.1 21.85H22.5Q21.9 19.05 19.5 17.025Q17.1 15 14 15Q10.25 15 7.625 17.625Q5 20.25 5 24Q5 27.75 7.625 30.375Q10.25 33 14 33Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default React.memo(KeyOn)
